import NoAttachmentIcon from '@nv/images/design/no-attachment-icon'
import { useTranslation } from 'react-i18next'
import styles from './NoAttachmentsMessage.module.scss'

const NoAttachmentsMessage = () => {
  const { t } = useTranslation()

  return (
    <div className={styles['container']}>
      <NoAttachmentIcon />
      <span className={styles['text']}>{t('events.noAttachments')}</span>
    </div>
  )
}

export default NoAttachmentsMessage
